import { CropFree, ZoomInMap } from "@mui/icons-material";
import { Grid, IconButton, Typography } from "@mui/material";
import React, { useRef, useState } from "react";
import { useStyle } from "../style";
import BillingTable from "./billingTable";
import CustomerInfo from "./customerInfo";
import PurchaseInfo from "./purchaseInfo";
import moment from "moment";
import { Helmet } from "react-helmet-async";

const Wastage = () => {
  const classes = useStyle();
  const fullscreenRef = useRef(null);
  const [isFull, setIsFull] = useState(false);
  const [data, setData] = useState([])
  const [code,setCode] = useState('')
  const codeRef = useRef(null)
  const [poDetails , setPoDetails] = useState({
    docDate:moment().format(),
  })
  const [postData ,setPostData] = useState({
  date: "",
  amount: 0,
  totalQty: 0,
  company_id: 22,
  uid: 10,
  wastage_detail: []
  })
  // const toggleFullscreen = () => {
  //   if (!isFull) {
  //     if (fullscreenRef.current) {
  //       if (fullscreenRef.current.requestFullscreen) {
  //         fullscreenRef.current.requestFullscreen();
  //       } else if (fullscreenRef.current.mozRequestFullScreen) {
  //         fullscreenRef.current.mozRequestFullScreen();
  //       } else if (fullscreenRef.current.webkitRequestFullscreen) {
  //         fullscreenRef.current.webkitRequestFullscreen();
  //       } else if (fullscreenRef.current.msRequestFullscreen) {
  //         fullscreenRef.current.msRequestFullscreen();
  //       }
  //       setIsFull(true);
  //       document.addEventListener('keydown', escapeKeyHandler);
  //     }
  //   } else {
  //     if (document.exitFullscreen) {
  //       document.exitFullscreen();
  //     } else if (document.mozCancelFullScreen) {
  //       document.mozCancelFullScreen();
  //     } else if (document.webkitExitFullscreen) {
  //       document.webkitExitFullscreen();
  //     } else if (document.msExitFullscreen) {
  //       document.msExitFullscreen();
  //     }
  //     setIsFull(false);
  //     document.removeEventListener('keydown', escapeKeyHandler);
  //   }
  // };

  const toggleFullscreen = () => {
    if (!isFull) {
      if (fullscreenRef.current) {
        if (fullscreenRef.current.requestFullscreen) {
          fullscreenRef.current.requestFullscreen();
        } else if (fullscreenRef.current.mozRequestFullScreen) {
          fullscreenRef.current.mozRequestFullScreen();
        } else if (fullscreenRef.current.webkitRequestFullscreen) {
          fullscreenRef.current.webkitRequestFullscreen();
        } else if (fullscreenRef.current.msRequestFullscreen) {
          fullscreenRef.current.msRequestFullscreen();
        }
      }
      setIsFull(true);
      document.addEventListener('keydown', escapeKeyHandler);
    } else {
      if (document.fullscreenElement) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      } else if (document.mozFullScreenElement) {
        if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        }
      } else if (document.webkitFullscreenElement) {
        if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        }
      } else if (document.msFullscreenElement) {
        if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      }
      setIsFull(false);
      document.removeEventListener('keydown', escapeKeyHandler);
    }
  };

  const escapeKeyHandler = (event) => {
    if (event.key === 'Escape') {
      toggleFullscreen();
      setIsFull(prevIsFull => !prevIsFull); // Toggle the isFull state
    }
  };
  
  return (
    <Grid ref={fullscreenRef} className={classes.root}>
      <Helmet><title>Damage</title></Helmet>
      <Grid className={classes.titleInfo}>
        <Typography variant="h5" fontWeight={600}>Damage</Typography>
        {isFull ? <IconButton onClick={toggleFullscreen}><ZoomInMap /></IconButton>
         : <IconButton onClick={toggleFullscreen}><CropFree /></IconButton>}
      </Grid>
      <Grid className={classes.contentGrid}>
        <Grid className="w-5/6" sx={{display: 'flex', flexDirection:'column',  flex: 1,}}>
          <Grid className="border-b" sx={{height:'fit-content'}}><PurchaseInfo setPostData={setPostData}  postData={postData} poDetails={poDetails} setPoDetails={setPoDetails}/></Grid>
          <Grid className="p-2 " sx={{flex:1, height:'100%'}}><BillingTable data={data} setData={setData} code={code} setCode={setCode} ref={codeRef} setPostData={setPostData} poDetails={poDetails} setPoDetails={setPoDetails}/></Grid>
        </Grid>
        <Grid className="w-1/6 h-full border-l py-2">
          <Grid className="border-b px-3">
            <CustomerInfo data={data} setData={setData} postData={postData} setPostData={setPostData}/>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Wastage;
